// src/components/PrivacyModal.jsx
import React from 'react'
import ReactDOM from 'react-dom'
import { X } from 'lucide-react'

export function PrivacyModal({ onClose }) {
  return ReactDOM.createPortal(
    <div style={{
      position: 'fixed', inset: 0,
      background: 'rgba(0,0,0,0.55)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9100,
      padding: '16px',
      boxSizing: 'border-box',
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 16,
        width: '100%',
        maxWidth: 560,
        maxHeight: '88vh',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 20px 60px rgba(0,0,0,0.22)',
        overflow: 'hidden',
      }}>
        {/* ヘッダー（固定） */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '18px 20px 14px',
          borderBottom: '1px solid #f3f4f6',
          flexShrink: 0,
        }}>
          <h2 style={{ fontSize: 18, fontWeight: 700, color: '#1a1a2e', margin: 0 }}>
            プライバシーポリシー
          </h2>
          <button
            onClick={onClose}
            style={{
              background: 'none', border: 'none', cursor: 'pointer',
              color: '#6b7280', padding: 6, borderRadius: 8,
              display: 'flex', alignItems: 'center',
            }}
          >
            <X size={22} />
          </button>
        </div>

        {/* コンテンツ（スクロール可能） */}
        <div style={{
          flex: 1,
          minHeight: 0,
          overflowY: 'auto',
          WebkitOverflowScrolling: 'touch',
          padding: '18px 20px 24px',
          fontSize: 13,
          lineHeight: 1.85,
          color: '#374151',
        }}>
          <Section title="1. 取得する情報">
            <p style={{ margin: '0 0 8px' }}>本サービスでは、以下の情報を取得します。</p>
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              <li>メールアドレス</li>
              <li>アカウント識別子（UID）</li>
              <li>Googleアカウントに登録された公開プロフィール情報（表示名、プロフィール画像URL等）</li>
              <li>本サービス上で投稿されたコンテンツおよび利用履歴</li>
            </ul>
            <p style={{ margin: '8px 0 0' }}>本サービスはパスワード情報を取得・保存しません。</p>
          </Section>

          <Section title="2. 利用目的">
            <p style={{ margin: '0 0 8px' }}>取得した情報は以下の目的で利用します。</p>
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              <li>アカウント管理</li>
              <li>本サービスの提供・改善</li>
              <li>不正利用防止</li>
              <li>投稿内容の安全性確認</li>
              <li>お問い合わせ対応</li>
            </ul>
          </Section>

          <Section title="3. 外部サービスの利用">
            <p style={{ margin: '0 0 8px' }}>本サービスは以下の外部サービスを利用します。</p>
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              <li><strong>Google</strong>（Google LLC）：アカウント認証に利用します。</li>
              <li><strong>Supabase</strong>（Supabase Inc.）：データベースおよびユーザー情報の保存に利用します。</li>
              <li><strong>OpenAI</strong>（OpenAI, L.L.C.）：投稿内容の自動安全性審査に利用します。審査のため投稿テキストをOpenAIのAPIに送信することがあります。</li>
              <li>広告配信サービス（Google AdSense等）：広告配信事業者はCookieを使用することがあります。ユーザーはブラウザ設定によりCookieを無効化できます。</li>
            </ul>
          </Section>

          <Section title="4. 第三者提供">
            法令に基づく場合を除き、取得した個人情報を第三者へ提供することはありません。
          </Section>

          <Section title="5. 情報の保存および削除">
            利用者は、アカウント削除を希望する場合、本サービス所定の方法により申請できます。削除後は合理的期間内に情報を消去します。
          </Section>

          <Section title="6. お問い合わせ">
            個人情報の取り扱いに関するお問い合わせは、本サービス内のお問い合わせフォームよりご連絡ください。
          </Section>

          <p style={{ marginTop: 24, color: '#9ca3af', fontSize: 12 }}>
            制定日：2026年2月20日
          </p>
        </div>
      </div>
    </div>,
    document.body
  )
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: 20 }}>
      <h3 style={{ fontSize: 14, fontWeight: 700, color: '#1a1a2e', marginBottom: 8 }}>
        {title}
      </h3>
      <div>{children}</div>
    </div>
  )
}
